// Per-user progress on the server. The token identifies the user; the server owns the mapping.
const TK = 'tt-token';

export const getToken = () => {
  try { return localStorage.getItem(TK) || ''; } catch { return ''; }
};
export const setToken = (t) => {
  try { t ? localStorage.setItem(TK, t) : localStorage.removeItem(TK); } catch { /* private mode */ }
};

const headers = () => ({ 'content-type': 'application/json', authorization: `Bearer ${getToken()}` });

async function call(init) {
  const r = await fetch('/api/progress', { cache: 'no-store', ...init, headers: headers() });
  if (r.status === 401) throw new Error('unauthorized');
  if (!r.ok) throw new Error(`http ${r.status}`);
  return r.json();
}

/** -> { user, progress | null } */
export const pull = () => call({});
/** -> { ok, stale?, progress? }  (stale: the server holds a newer copy and returns it) */
export const push = (progress) => call({ method: 'PUT', body: JSON.stringify(progress) });
